export class GenericChangeEvent extends Event {
  set target(element) {
    this._target = element;
  }
  get target() {
    return this._target;
  }
  set currentTarget(element) {
    this._target = element;
  }
  get currentTarget() {
    return this._target;
  }
  preventDefault() {
    super.preventDefault();
    this._defaultPrevented = true;
  }
  isDefaultPrevented() {
    return this._defaultPrevented;
  }
  stopPropagation() {
    super.stopPropagation();
    this._propagationStopped = true;
  }
  isPropagationStopped() {
    return this._propagationStopped;
  }
  persist() {
    this._persisted = true;
  }
}
